const baseURL = 'https://dvasti.com/';

export default baseURL;
